import React from "react";
import Reveal from "../common/Reveal";
import { writingMode, posts } from "../data/writing";

export default function Writing() {
  const isLive = writingMode === "live";

  return (
    <section id="writing" className="section">
      <div className="section-inner">
        <Reveal className="section-label-row tight">
          <span className="section-label mono">06 / WRITING</span>
          <span className="section-line" />
          <span className="projects-count mono">
            {isLive ? "the blog" : "coming soon"}
          </span>
        </Reveal>

        {!isLive && (
          <Reveal className="status-card">
            <span className="status-pill mono">
              <span className="pulse-dot" />
              COMING SOON
            </span>
            <h2 className="status-headline">The blog is warming up</h2>
            <p className="status-copy">
              Long-form notes on the systems I ship are in the works.
              Deep-dives will appear here soon — the good stuff, no filler.
            </p>
            <p className="status-note mono">
              {"// no posts published yet — check back soon"}
            </p>
          </Reveal>
        )}

        {isLive && (
          <>
            <Reveal as="h2" className="section-headline">
              Notes on building things.
            </Reveal>
            <Reveal as="p" className="section-sub">
              This space is wired up and ready — a home for deep-dives on the
              systems I ship. Drafts below.
            </Reveal>

            <div className="writing-list stagger">
              {posts.map((post) => (
                <Reveal
                  as="a"
                  href="#writing"
                  className="lnk writing-row"
                  key={post.title}
                >
                  <span className="writing-label mono">{post.label}</span>
                  <div className="writing-content">
                    <h3 className="writing-title">{post.title}</h3>
                    <p className="writing-excerpt">{post.excerpt}</p>
                  </div>
                  <span className="writing-tag mono">{post.tag}</span>
                </Reveal>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
